import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  FiHome,
  FiChevronRight,
  FiCopy,
  FiCheck,
} from "react-icons/fi";

import { getProfile } from "../../store/slices/profile";

const Invite = () => {
  const dispatch = useDispatch();

  const [copiedLink, setCopiedLink] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);

  const { profile, user, loading } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  const profileData =
    profile?.data ||
    profile ||
    user?.data ||
    user ||
    {};

  const userId = profileData?.userId || "";
  const userStatus = profileData?.status || "";

  const isPending = userStatus === "PENDING";

  const invitationCode = userId;

  const invitationLink =
    userId && !isPending
      ? `https://globalinavation.com/referral/${userId}`
      : "";

  const handleCopyLink = async () => {
    if (!invitationLink || isPending) return;

    try {
      await navigator.clipboard.writeText(invitationLink);

      setCopiedLink(true);

      setTimeout(() => {
        setCopiedLink(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to copy link:", error);
    }
  };

  const handleCopyCode = async () => {
    if (!invitationCode || isPending) return;

    try {
      await navigator.clipboard.writeText(invitationCode);

      setCopiedCode(true);

      setTimeout(() => {
        setCopiedCode(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to copy code:", error);
    }
  };

  return (
    <div className="gi-transfer-page">

      {/* Breadcrumb */}
      <div className="gi-breadcrumb">

        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Invite</span>

      </div>

      {/* Pending User */}
      {isPending ? (
        <div className="gi-invite-card">
          <h2>Invitation</h2>

          <p className="gi-invite-description">
            Your account is pending approval.
          </p>

          <p className="gi-invite-help-text">
            Your invitation link and invitation code will be available
            after your account is activated.
          </p>
        </div>
      ) : (
        /* Active User */
        <div className="gi-invite-grid">

          {/* Invitation Link */}
          <section className="gi-invite-card">

            <h2>Invitation Link</h2>

            <p className="gi-invite-description">
              Share this link to invite users to join:
            </p>

            <div className="gi-invite-link-box">

              <div className="gi-invite-link-text">
                {loading
                  ? "Loading..."
                  : invitationLink || "Invitation link unavailable"}
              </div>

              <button
                type="button"
                className="gi-invite-copy-btn"
                onClick={handleCopyLink}
                disabled={!invitationLink}
              >
                {copiedLink ? (
                  <>
                    <FiCheck />
                    Copied
                  </>
                ) : (
                  <>
                    <FiCopy />
                    Copy
                  </>
                )}
              </button>

            </div>

            <p className="gi-invite-help-text">
              Click the button to copy the link
            </p>

          </section>

          {/* Invitation Code */}
          <section className="gi-invite-card">

            <h2>Invitation Code</h2>

            <p className="gi-invite-description">
              Share this code to invite users:
            </p>

            <div className="gi-invite-code">
              {loading
                ? "Loading..."
                : invitationCode || "Unavailable"}
            </div>

            <button
              type="button"
              className="gi-invite-code-copy-btn"
              onClick={handleCopyCode}
              disabled={!invitationCode}
            >
              {copiedCode ? (
                <>
                  <FiCheck />
                  Copied
                </>
              ) : (
                <>
                  <FiCopy />
                  Copy Code
                </>
              )}
            </button>

            <p className="gi-invite-help-text">
              Click the button to copy the code
            </p>

          </section>

        </div>
      )}
    </div>
  );
};

export default Invite;